export default __webpack_public_path__ + "static/media/add-icon.94c6099d.svg";